import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
export const finiteNumber: ValidatorFn = c => c.value === null || c.value === undefined || typeof c.value === 'boolean' || String(c.value).trim() === '' ? { required: true } : Number.isFinite(Number(c.value)) ? null : { finiteNumber: true };
export const nonNegative: ValidatorFn = c => finiteNumber(c) || (Number(c.value) >= 0 ? null : { nonNegative: true });
export const positive: ValidatorFn = c => finiteNumber(c) || (Number(c.value) > 0 ? null : { positive: true });
export const optionalPositive: ValidatorFn = c => c.value === null || c.value === '' ? null : positive(c);
export const acceptanceLimits: ValidatorFn = c => {
 const lo = c.get('LowerLimit'), hi = c.get('UpperLimit');
 return lo && hi && !finiteNumber(lo) && !finiteNumber(hi) && Number(lo.value) >= Number(hi.value) ? { acceptanceLimits: true } : null;
};
export const repeatReadings: ValidatorFn = c => {
 const count = c.get('Observations')?.value?.length || 0;
 return count < (Number(c.get('UncertaintyEstimate')?.value) === 1 ? 4 : 2) ? { minimumReadings: true } : null;
};
export const uniquePoints: ValidatorFn = c => {
 if (c.get('Unit')?.value !== 'g') { return { invalidUnit: true }; }
 const rows = c.get('Points')?.value || [], ids = rows.map(x => x.NModel.Value), measurements = rows.map(x => x.NModel.MeasurementId);
 return !rows.length ? { minimumPoints: true } : new Set(ids).size !== ids.length || new Set(measurements).size !== measurements.length ? { duplicatePoint: true } : null;
};
